import React, { useState } from "react"
 import { Content } from "./style"
import freight_act from '../../../assets/router/routersTabHeader/freight-active.svg';
import freight from '../../../assets/router/routersTabHeader/freight.svg';
import local_act from '../../../assets/sidemenu/local-active.svg';
import local from '../../../assets/sidemenu/local.svg';
import dateAndTime_act from '../../../assets/router/routersTabHeader/dateAndTime-active.svg';
import dateAndTime from '../../../assets/router/routersTabHeader/dateAndTime.svg';
import vehicles_act from '../../../assets/router/routersTabHeader/vehicle-active.svg';
import vehicles from '../../../assets/router/routersTabHeader/vehicle.svg';
import { ButtonCreate, LeftSide, OptionsButton, RightSide, SectionName, SubHeaderContainer, Tab, TabsDiv } from "../../../components/styles/subheader-style"
import { Outlet, useLocation, useNavigate, useOutletContext } from "react-router-dom"
import { TypeMainOutlet } from ".."
import RoutersTabHeader from "../../../components/router/routersTabHeader";
import RouterButtons from "./routerButtons";
export interface RouterOutletType {
    tabIndex: number
    setTabIndex: React.Dispatch<React.SetStateAction<number>>
  }

  interface RouterBody{
    id: number;
    date: string;
    status: string;
    freightIds: number[];
    track: string | undefined;
    url: string;
    origin: string;
    vehicleId: number;
  }

const tabs = [
    {path: '', image: freight_act, name: 'Fretes'},
    {path: 'routers', image: local_act, name: 'Roteiros'},
    // {path: 'vehicles', image: vehicles_act, name: 'Veículos'},
    // {path: 'dateAndTime', image: dateAndTime_act, name: 'Datas e horários'},
    // {path: 'teste', image: dateAndTime_act, name: 'teste'}

]

const RouterSubHeader:React.FC<{tabIndexActived:number}> = ({tabIndexActived})=>{
    const navigate = useNavigate() 
    const location = useLocation();
    return(
        <SubHeaderContainer>
        <LeftSide>
            <SectionName>Roterização</SectionName>
       {(location.pathname !== '/panel/router/routers/create' && location.pathname !== '/panel/router/routers/edit') &&
        <TabsDiv>
        {tabs.map((tab, index) => (
        <Tab
          key={index}
          $isFirst={index === 0}
          $isLast={index === tabs.length - 1}
          $isActive={index === tabIndexActived}
          onClick={() => {
            if(index !== tabIndexActived) navigate(tab.path)
          }}
        >
            <img src={tab.image} alt={`${tab.path}-icon`} />
            {tab.name}
        </Tab>
        ))}
      </TabsDiv>}
        </LeftSide>
        <RightSide>
        {(location.pathname !== '/panel/router/routers/create' && location.pathname !== '/panel/router/routers/edit') &&
          <RouterButtons index={tabIndexActived}/>
        }
        </RightSide>
        </SubHeaderContainer>
    )
} 
const RouterContent = ()=>{
    // const [loading, setLoading] = useState<boolean>(true)
    const [ tabIndex, setTabIndex ] = useState<number>(0)
    const { search } = useOutletContext<TypeMainOutlet>()
    const [bodyRouter, setBodyRouter] = useState<RouterBody>(
      {
        id:0,
        date : '',
        status: "A programar",
        freightIds: [],
        track: '',
        url: 'https://www.google.com.br/maps?q=06278-010,%20Brasil&output=embed',
        origin: 'vendas',
        vehicleId: 0
      }
    )
   
    return (
        <>
        
        <RouterSubHeader tabIndexActived={tabIndex}/>
        <Content>
        <Outlet
            context={{
              tabIndex,
              setTabIndex,
              search
            }}
          />
        </Content>
        </>
    )
}
export default RouterContent